// frontend/src/services/dashboardService.js - FIXED VERSION
import { API_URL } from '../config.js';

class DashboardService {
  getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  async getAllDashboards() {
    try {
      const response = await fetch(`${API_URL}/dashboards`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch dashboards');
      }

      return data.dashboards;
    } catch (error) {
      console.error('Error fetching dashboards:', error);
      throw error;
    }
  }

  async getDashboard(dashboardId) {
    try {
      const response = await fetch(`${API_URL}/dashboards/${dashboardId}`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to fetch dashboard');
      }

      return data.dashboard;
    } catch (error) {
      console.error('Error fetching dashboard:', error);
      throw error;
    }
  }

  async createDashboard(name, plantId, panels = [], isDefault = false, variables = []) {
    try {
      const response = await fetch(`${API_URL}/dashboards`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify({ name, plantId, panels, isDefault, variables })
      });

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to create dashboard');
      }

      return data.dashboard;
    } catch (error) {
      console.error('Error creating dashboard:', error);
      throw error;
    }
  }

  async updateDashboard(dashboardId, updates) {
    try {
      const response = await fetch(`${API_URL}/dashboards/${dashboardId}`, {
        method: 'PUT',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(updates)
      });

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to update dashboard');
      }

      return data.dashboard;
    } catch (error) {
      console.error('Error updating dashboard:', error);
      throw error;
    }
  }

  async updateVariables(dashboardId, variables) {
    try {
      const response = await fetch(`${API_URL}/dashboards/${dashboardId}/variables`, {
        method: 'PATCH',
        headers: this.getAuthHeaders(),
        body: JSON.stringify({ variables })
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || 'Failed to update variables');
      }

      return data.dashboard;
    } catch (error) {
      console.error('Error updating variables:', error);
      throw error;
    }
  }

  async deleteDashboard(dashboardId) {
    try {
      const response = await fetch(`${API_URL}/dashboards/${dashboardId}`, {
        method: 'DELETE',
        headers: this.getAuthHeaders()
      });

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to delete dashboard');
      }

      return data;
    } catch (error) {
      console.error('Error deleting dashboard:', error);
      throw error;
    }
  }

  async updatePanels(dashboardId, panels) {
    try {
      const response = await fetch(`${API_URL}/dashboards/${dashboardId}/panels`, {
        method: 'PATCH',
        headers: this.getAuthHeaders(),
        body: JSON.stringify({ panels })
      });

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to update panels');
      }

      return data.dashboard;
    } catch (error) {
      console.error('Error updating panels:', error);
      throw error;
    }
  }

  // Sync dashboards - MongoDB is the source of truth
  // REMOVED localStorage migration to prevent dashboards leaking between users
  async syncDashboards() {
    try {
      // Get dashboards from MongoDB (filtered by userId on backend)
      const remoteDashboards = await this.getAllDashboards();

      // Clear any stale localStorage dashboards (they may belong to a different user)
      localStorage.removeItem('miralys_dashboards');

      console.log('📥 Loaded dashboards from server:', remoteDashboards.length);
      return remoteDashboards;
    } catch (error) {
      console.error('Error fetching dashboards:', error);
      // Return empty array on error - don't use localStorage fallback
      // as it may contain another user's data
      console.log('⚠️  Failed to fetch dashboards, returning empty list');
      return [];
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;